

export const DerbySoftMUItheme = {
    palette: {
        primary: {
            main: '#06789D'
        },

        secondary: {
            main: '#3c8ba6'
        },

        error: {
            main: '#E51313'
        },

        contrastThreshold: 3,

        tonalOffset: 0.2
    },
    overrides: {
        MuiInput: {
            root: {
                fontSize: '14px'
            },

            underline: {
                borderBottom: `1px solid #e3e3e3`,
                "&:before": {
                    borderBottom: `none`,
                    bottom: '-1px'
                },
                "&:after": {
                    borderBottom: `2px solid #3c8ba6`,
                    bottom: '-1px'
                },
                "&:hover:not($disabled):before": {
                    borderBottom: `1px solid #06789D`
                },
                '&.Mui-disabled:before': {
                    'border-bottom-style': 'initial'
                }
            }
        },
    }
}